// extracted by mini-css-extract-plugin
export default {"icon":"Table_icon__y4412","responsive":"Table_responsive__A1BBL"};